import angular from 'angular';

import UserLogService from './UserLogService';
import UserLogComponent from './UserLogComponent';

export default angular
  .module('petroCloud.admin.userLog', [])
  .service('UserLogService', UserLogService)
  .component(UserLogComponent.name, UserLogComponent)
  .name;
